import {
  GETAGENTSNAMESREQUEST,
  GETAGENTSREQUEST,
  GETDISTRIBUTORNAMESREQUEST,
  GETDISTRIBUTORREQUEST,
  GETFASTAGREQUEST,
  GETINVENTORYAGENTREQUEST,
  GETINVENTORYDISTRIBUTORREQUEST,
  GETINVENTORYREQUEST,
  GETREPORTREQUEST,
  LOGINREQUEST,
  LOGOUT,
  GETSTATEREQUEST,
  GETCITYREQUEST,
  SENDOTPREQUEST,
  CHANGEPASSWORDREQUEST,
  EDITDISTRIBUTORREQUEST,
  GETMASTERFASTAGREQUEST,
  GETALLAGENTSNAMESREQUEST,
  GETINVENTORYSUMMARYREQUEST,
  CREATEDISTRIBUTORBULKREQUEST,
  CREATEAGENTBULKREQUEST,
  GETDISTRIBUTORSUMMARYREQUEST,
  GETDISTRIBUTORAGENTSUMMARYREQUEST,
  GETAGENTSUMMARYREQUEST,
  GETDISTRIBUTORREQUESTREQUEST,
  ASSIGNAGENTEXCELREQUEST,
  GETALLFASTAGAGENTREQUESTREQUEST,
  GETAGENTFASTAGREQUEST,
  UPDATEAGENTREQUESTSTATUSREQUEST,
  DENIEDREQUESTSTATUSREQUEST,
  ASSIGNDISTRIBUTOREXCELREQUEST,
  GET_AGENTS_DISTRIBUTOR_WISE_REQUEST,

} from "./actionTypes";

export const ACTIONS = {
  LoginAction: (params) => ({ type: LOGINREQUEST, params }),
  GetInventoryAction: (params) => ({ type: GETINVENTORYREQUEST, params }),
  GetReportAction: (params) => ({ type: GETREPORTREQUEST, params }),
  GetFastagAction: (params) => ({ type: GETFASTAGREQUEST, params }),
  GetAgentsAction: (params) => ({ type: GETAGENTSREQUEST, params }),
  GetAgentsNamesAction: (params) => ({ type: GETAGENTSNAMESREQUEST, params }),
  GetInventoryDistributorAction: (params) => ({ type: GETINVENTORYDISTRIBUTORREQUEST, params }),
  GetDistributorAction: (params) => ({ type: GETDISTRIBUTORREQUEST, params }),
  GetDistributorNamesAction: (params) => ({ type: GETDISTRIBUTORNAMESREQUEST, params }),
  GetInventoryAgentAction: (params) => ({ type: GETINVENTORYAGENTREQUEST, params }),
  clearLogin: () => ({ type: LOGOUT }),
  GetStateAction: (params) => ({ type: GETSTATEREQUEST, params }),
  GetCityAction: (params) => ({ type: GETCITYREQUEST, params }),
  SendOtpAction: (params) => ({ type: SENDOTPREQUEST, params }),
  ChangePasswordAction: (params) => ({ type: CHANGEPASSWORDREQUEST, params }),
  EditDistributorAction: (distributorId, params) => ({ type: EDITDISTRIBUTORREQUEST, distributorId, params }),
  GetMasterFastagAction: (params) => ({ type: GETMASTERFASTAGREQUEST, params }),
  GetAllAgentsNamesAction: (params) => ({ type: GETALLAGENTSNAMESREQUEST, params }),
  GetInventorySummaryAction: () => ({ type: GETINVENTORYSUMMARYREQUEST }),
  CreateDistributorBulkAction: (params) => ({ type: CREATEDISTRIBUTORBULKREQUEST, params }),
  CreateAgentBulkAction: (params) => ({ type: CREATEAGENTBULKREQUEST, params }),
  GetDistributorSummaryAction: () => ({ type: GETDISTRIBUTORSUMMARYREQUEST }),
  GetDistributorAgentSummaryAction: (params) => ({ type: GETDISTRIBUTORAGENTSUMMARYREQUEST, params }),
  GetAgentSummaryAction: () => ({ type: GETAGENTSUMMARYREQUEST }),
  GetDistributorRequestAction: (params) => ({ type: GETDISTRIBUTORREQUESTREQUEST, params }),
  AssignAgentExcelAction: (params) => ({ type: ASSIGNAGENTEXCELREQUEST, params }),
  GetAllFastagAgentRequestAction: (params) => ({ type: GETALLFASTAGAGENTREQUESTREQUEST, params }),
  GetAgentFastagAction: (params) => ({ type: GETAGENTFASTAGREQUEST, params }),
  UpdateAgentRequestStatusAction: (params) => ({ type: UPDATEAGENTREQUESTSTATUSREQUEST, params }),
  DeniedRequestAction: (params) => ({ type: DENIEDREQUESTSTATUSREQUEST, params }),
  AssignDistributorExcelAction: (params) => ({ type: ASSIGNDISTRIBUTOREXCELREQUEST, params }),
  GetAgentsDistributorWiseAction: (params) => ({ type: GET_AGENTS_DISTRIBUTOR_WISE_REQUEST, params }),
};

